import { gql } from "@apollo/client";
import TimeformFragment from "./Timeform";

export default gql`
  fragment BettingInterests on Race {
    bettingInterests {
      biNumber
      saddleColor
      numberColor
      favorite
      currentOdds {
        numerator
        denominator
      }
      morningLineOdds {
        numerator
        denominator
      }
      recentOdds(pages: { current: 0, results: 4 }) {
        trending
        odd
      }
      runners {
        runnerId
        scratched
        horseName
        age
        sex
        weight
        med
        jockey
        trainer
        dob
        entityRunnerId
        hasJockeyChanges
        winProbability
        handicapping {
          freePick {
            number
            info
          }
          speedAndClass {
            normalisedSpeedRating
            highSpeed
            highSpeedRanking
          }
          snapshot {
            normalisedPowerRating
            powerRating
            powerRatingRanking
          }
          pastResults {
            numberOfFirstPlace
            numberOfSecondPlace
            numberOfThirdPlace
            totalNumberOfStarts
            winPercentage
            winPercentageRanking
            top3Percentage
            top3PercentageRanking
          }
          jockeyTrainer {
            starts
            wins
            places
            shows
          }
          averagePace {
            early
            middle
            finish
          }
        }
        ...Timeform
      }
    }
  }
  ${TimeformFragment}
`;
